"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
const calculate_1 = require("./calculate");
__exportStar(require("./calculate"), exports);
function calc(opJson, playDataJson) {
    if (opJson === undefined ||
        opJson === '' ||
        playDataJson === undefined ||
        playDataJson === '') {
        return 'Argument error.';
    }
    return (0, calculate_1.calculateJson)(opJson, playDataJson);
}
function setUpcId(upcId) {
    return (0, calculate_1.setSeed)(upcId);
}
try {
    // @ts-ignore
    window.calculate = calc;
    // @ts-ignore
    window.setUpcId = setUpcId;
}
catch (ex) {
    //
}
function noop() {
    //
}
try {
    setInterval(noop, 1000);
}
catch (ex) {
    // iOS JSCore has no setInterval.
}
